<!-- Modal -->
<ng-template #paymentMethodsPopup aria-hidden="true" aria-labelledby="exampleModalLabel" class="modal fade modal-dialog" data-bs-backdrop="static" id="paymentMethodsPopup" tabindex="-1">
    <div class="modal-content">
        <div *ngIf="popupMode == PopupMode.CHOOSE_CARD" class="modal-header">
            <h5 class="modal-title">Choose or Create a Payment Method</h5>
            <div (click)="reset()" class="icon-button float-end"><i class="fa fa-times"></i></div>
        </div>

        <div *ngIf="popupMode == PopupMode.ADD_CARD" class="modal-header">
            <h5 class="modal-title">Add a Credit Card</h5>
            <div (click)="toggleForm()" class="icon-button float-end"><i class="fa fa-times"></i></div>
        </div>

        <div *ngIf="popupMode == PopupMode.OTP_SECURE" class="modal-header">
            <h5 class="modal-title">SMS verification required</h5>
            <div (click)="reset()" class="icon-button float-end"><i class="fa fa-times"></i></div>
        </div>

        <div class="modal-body">
            <div *ngIf="popupMode == PopupMode.CHOOSE_CARD">
                <div
                    (click)="changeSelectedCard(paymentMethod.$key)"
                    *ngFor="let paymentMethod of paymentMethods"
                    [ngClass]="{ active: selectedPaymentMethod.$key == paymentMethod.$key }"
                    class="container paymentMethod card rounded mb-3 py-2"
                >
                    <div class="row">
                        <div class="col-2 vwcenter-parent">
                            <span class="vwcenter">
                                <input [checked]="selectedPaymentMethod.$key == paymentMethod.$key ? true : null" class="form-check-input" id="flexRadioDefault1" name="cardRadioButton" type="radio" />
                            </span>
                        </div>
                        <div class="col-10">
                            <div>
                                <i class="fa-brands {{ paymentMethod.icon }}"></i>
                                {{ paymentMethod.cardNo }}
                            </div>
                            <div class="d-flex justify-content-between">
                                <div class="font-weight-bold">{{ paymentMethod.nameOnCard }}</div>
                                <div>{{ paymentMethod.expiryDate | formatDate }}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div style="text-align: center" *ngIf="paymentMethods && paymentMethods.length == 0">
                    <a (click)="toggleForm()" class="btn btn-primary btn-lg">
                        <div class="btn-line-1 text-black">Add Credit Card</div>
                        <div class="btn-line-2 text-black">Add your first card to submit your parking request</div>
                    </a>

                    <!-- <div class="mt-4">
                        <a (click)="reset()" class="link-danger mt-2 text-decoration-underline">Cancel request</a>
                    </div> -->
                </div>
                <div *ngIf="paymentMethods.length > 0">
                    <a (click)="toggleForm()" class="text-info text-decoration-underline"> Add Your Card </a>
                </div>
            </div>

            <div *ngIf="popupMode == PopupMode.HOW_IT_WORKS">
                <div class="modal-header p-0">
                    <h5 class="modal-title">How It Works</h5>
                    <div (click)="exitHowItWorks()" class="icon-button float-end"><i class="fa fa-times"></i></div>
                </div>

                <div class="mt-3">
                    <p>Before proceeding with your parking lease, here’s a quick overview of how payments and approvals work:</p>

                    <h5>1. Secure Payment Processing</h5>
                    <p>
                        We take your credit card details and tokenize them, meaning we don’t store your actual credit card information. This ensures your payment details remain secure while allowing
                        us to process future payments automatically.
                    </p>

                    <h5>2. Reservation Hold & Landlord Approval</h5>
                    <ul>
                        <li>We create a hold on your account for the amount due.</li>
                        <li>The landlord receives your booking request and has the option to accept or reject it.</li>
                        <li>If the landlord <strong>rejects</strong> the request, the hold is released, and the funds are returned to your account.</li>
                        <li>If the landlord <strong>accepts</strong>, we process the hold and complete the payment for your first month immediately.</li>
                    </ul>

                    <h5>3. Ongoing Payments</h5>
                    <p>
                        Your next invoice will be generated at the start of your second billing cycle. For example, if you're on a monthly lease, your second payment will be due at the start of your
                        second month.
                    </p>

                    <h5>4. Terms & Conditions</h5>
                    <p>By proceeding, you agree to:</p>
                    <ul>
                        <li>ParkUpp's terms and conditions as the marketplace provider.</li>
                        <li>The landlord’s specific terms, policies, and requirements for the parking space.</li>
                    </ul>
                    <p>If you have any questions, feel free to contact us before finalizing your booking.</p>

                    <div (click)="exitHowItWorks()" class="text-info text-decoration-underline"><i class="fa fa-arrow-left"></i> Back to payment methods</div>
                </div>
            </div>

            <div *ngIf="popupMode == PopupMode.ADD_CARD">
                <div class="">
                    <ul>
                        <li><b>We don’t store your card details</b>—PayGate securely does. <a href="https://payfast.io/security-fraud/" target="_blank">Learn more</a></li>
                        <li>As soon as you submit your request, we’ll place a hold on your first month’s payment. Once the parking manager approves your request, the hold will be processed.</li>
                        <li>To verify your account, we’ll also hold and return R1.00</li>
                        <li>Please enable online payments with your card</li>
                    </ul>
                </div>

                <div class="secured-block-title">This form is Secured by PayGate</div>
                <div class="secured-block">
                    <form #myForm="ngForm" (ngSubmit)="httpCreatePaymentMethod()" [formGroup]="formDataPaymentMethod" autocomplete="off" novalidate>
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="form-group">
                                    <label for="frmNameCC">Name on card</label>
                                    <input autocomplete="cc-name" class="form-control" formControlName="cardName" id="frmNameCC" name="ccname" placeholder="Initials Surname" required />
                                </div>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-sm-12">
                                <div class="form-group">
                                    <label for="frmCCNum">Card Number</label>
                                    <input autocomplete="cc-number" class="form-control" formControlName="cardNumber" id="frmCCNum" name="cardnumber" placeholder="0000 0000 0000 0000" required />
                                </div>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="form-group col-md-6">
                                <label for="frmCCExp">Expiry</label>
                                <input
                                    autocomplete="cc-exp"
                                    class="form-control"
                                    formControlName="cardExp"
                                    id="frmCCExp"
                                    name="cc-exp"
                                    placeholder="MM/YYYY"
                                    required
                                    (change)="checkExpiryDate($event)"
                                />
                                <div class="form-text" id="expHelp">Example: 09/2025</div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="frmCCCVC">CVV</label>
                                    <input autocomplete="cc-csc" class="form-control" formControlName="cardCvv" id="frmCCCVC" name="cvc" placeholder="123" required />
                                    <div class="form-text" id="cvvHelp">On the back of your card</div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div *ngIf="formError" class="col-12 mt-3">
                                <div class="form-group col-12 mt-3 alert alert-danger small" role="alert">
                                    {{ formError }}
                                </div>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="form-group col-sm-12 text-center">
                                <!-- <ng-container *ngIf="clientHasCard && !closeOnAdded">
                                <a (click)="toggleForm()" class="link-danger float-start mt-2">Back to payment methods</a>
                            </ng-container> -->

                                <button [disabled]="!formDataPaymentMethod.valid || formLoading == true" class="btn btn-sm btn-primary" type="submit">
                                    <span *ngIf="formLoading" aria-hidden="true" class="spinner-border spinner-border-sm mr-1" role="status"></span>

                                    <i class="mdi mdi-gamepad-circle"></i> Save Payment Method
                                </button>

                                <!-- <div class="mt-4">
                                <a (click)="reset()" class="link-danger mt-2 text-decoration-underline">Cancel request</a>
                            </div> -->
                            </div>
                        </div>
                    </form>
                </div>

                <div class="text-center mt-3">
                    <img src="/assets/images/paygate-secured.png" alt="Paygate Secured" class="img-fluid" />
                </div>
            </div>

            <div *ngIf="popupMode == PopupMode.OTP_SECURE">
                <iframe [src]="mpiIframeUrl | safe: 'resourceUrl'" height="400px" width="100%"></iframe>
            </div>

            <div *ngIf="popupMode == PopupMode.COMPLETE" class="text-center">
                <h2 class="mt-2">Your request has been sent to the parking manager</h2>
                <br />
                <p>You should hear back from the parking manager within 24 hours. Please look out for your email confirmation.</p>
                <br />
                <p>The final step is to provide us with your vehicle details.</p>
                <br />
                <div class="row justify-content-center">
                    <div class="form-group col-10 text-center">
                        <a (click)="closeToProfile()" class="btn btn-primary" type="button">
                            <div class="btn-line-1 text-black">My Vehicles</div>
                            <div class="btn-line-2 text-black">Click here to add your vehicle details</div>
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div
            *ngIf="this.selectedPaymentMethod && popupMode != PopupMode.ADD_CARD && popupMode != PopupMode.OTP_SECURE && popupMode != PopupMode.COMPLETE && popupMode != PopupMode.HOW_IT_WORKS"
            class="modal-footer"
        >
            <div class="col-12">
                <ng-container *ngIf="!updatingCreditCard">
                    <ng-container *ngIf="parking && parking.usePolicyUrl">
                        <div class="row">
                            <div class="col-12 mb-1 ms-1">
                                <div class="form-check d-flex align-items-center">
                                    <input (change)="toggleLandlordUsePolicyAccepted()" CHECKED class="form-check-input" id="ownerTerms" type="checkbox" value="" />
                                    <label class="terms-label mb-0 ms-2" for="ownerTerms">
                                        I agree to the Landlord's
                                        <a class="link-info text-decoration-underline" href="{{ parking.usePolicyUrl }}" target="_blank">Parking Use Policy and Terms</a>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="parking && parking.leaseAgreementUrl">
                        <div class="row">
                            <div class="col-12 mb-1 ms-1">
                                <div class="form-check">
                                    <input (change)="toggleLandlordLeaseAgreementAccepted()" CHECKED class="form-check-input mt-2" id="leaseAgreement" type="checkbox" value="" />
                                    <label class="terms-label" for="leaseAgreement">
                                        I understand that I will need to sign a
                                        <a class="link-info text-decoration-underline" href="{{ parking.leaseAgreementUrl }}" target="_blank">Lease Agreement</a>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="parking">
                        <div class="row">
                            <div class="col-12 mb-1 ms-1">
                                <div class="form-check">
                                    <input (change)="toggleParkUppTermsAccepted()" CHECKED class="form-check-input mt-2" id="terms" type="checkbox" value="" />
                                    <label class="terms-label" for="terms">
                                        I agree to ParkUpp's
                                        <a [routerLink]="['/terms-and-conditions']" class="link-info text-decoration-underline" target="_blank"> Terms and Conditions</a> as the marketplace
                                    </label>
                                </div>
                            </div>
                        </div>
                    </ng-container>

                    <div class="row">
                        <div class="form-group col-12 mt-2 text-center">
                            <button
                                (click)="httpProcessTokenPayment()"
                                [disabled]="!subscriptionLoaded || formLoading || !landlordUsePolicyAccepted || !landlordLeaseAgreementAccepted || !parkUppTermsAccepted"
                                class="btn btn-primary"
                                type="button"
                            >
                                <span *ngIf="formLoading" aria-hidden="true" class="spinner-border spinner-border-sm mr-1" role="status"></span>

                                <div class="btn-line-1 text-black">Send Parking Request</div>
                                <div class="btn-line-2 text-black">Submit parking request to the parking manager</div>
                            </button>

                            <!-- <div class="mt-4">
                                <a (click)="reset()" class="link-danger mt-2 text-decoration-underline">Cancel request</a>
                            </div> -->
                        </div>
                    </div>

                    <div *ngIf="parking">
                        <div class="row">
                            <div class="col-12 my-3">
                                <div class="text-center small text-muted">
                                    I understand that <b>R{{ getMonthlyFee() | number: '1.0-2' }} will be temporarily held</b> from my account today to reserve this parking. The amount will be
                                    deducted immediately if the landlord approves the booking.
                                    <a (click)="howItWorksModal()" class="link-info text-decoration-underline" target="_blank">Learn More</a> about the process.
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>

                <ng-container *ngIf="updatingCreditCard">
                    <div class="row">
                        <!-- <div class="form-group col-6">
                            <a (click)="reset()" class="link-danger float-start mt-2">Cancel request</a>
                        </div> -->

                        <div class="form-group col-6">
                            <button (click)="updatePaymentMethod()" [disabled]="!subscriptionLoaded || paymentMethodUpdating" class="btn btn-primary float-end" type="button">
                                <span *ngIf="paymentMethodUpdating" aria-hidden="true" class="spinner-border spinner-border-sm mr-1" role="status"></span>

                                <span>Update Card</span>
                            </button>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</ng-template>
